import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { ImagePath, ImageRelativePath } from '../../constants';
import { CardMedia } from '@mui/material';
import ProgressBar from './ProgressBar';
import CardContainer from '../../utils/CardContainer';
import { MovingText } from '../../utils/MovingText';
import { useToaster } from '../../utils/ToasterProvider';
import { useStudentMeeting } from '../../../assets/api/UseStudentGetApi';
import useAuthStore from '../../../store/useAuthStore';
import { useMutation } from '@tanstack/react-query';
import { getFormattedDate1 } from '../../formatter';
import api from '../../../assets/nodeApi/axiosInstance';

export function getCourseStatusColor(course_status) {
    switch (course_status) {
        case "Upcoming Class":
            return "yellow.main";
        case "Ongoing Class":
            return "green.main";
        case "Completed Class":
            return "blue.main";
        default:
            return "gray";
    }
}

const CurrentClassCard = ({ item }) => {
    const { user, token } = useAuthStore()
    const {
        title,
        start_date,
        end_date,
        batch_name,
        course_status,
        category_name,
        cover_image,
        course_id,
        trainer_id,
        batch_id,
        apartment_name
    } = item
    const { data: meetingLink} = useStudentMeeting({batchId:batch_id})
    const { showToaster } = useToaster();
    const details = [
        // { label: "Batch", value: batch_name },
        !apartment_name && { label: "Batch", value: batch_name },
        { label: "From", value: start_date },
    ];
    const additionalDetails = [
        { label: "To", value: end_date },
        { label: "status", value: `${course_status}` },
    ];
    const createMutation = useMutation({
        mutationFn: (formData) => api.post("student-attendance/create", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }),
    });

    const handleStudentAtd = () => {
        const obj = {
            student_data: [{
                "student_id": user?.id,
                "attendance_status": "1",
                "remarks": "Good engagement",

            }],
            trainer_id: trainer_id,
            attendance_date: getFormattedDate1(),
            course_id: course_id,
            batch_id: batch_id,

        }
        createMutation.mutate(obj, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    showToaster('Student Marked Present', '', 'success')
                } else {
                    showToaster('Something went wrong!', '', 'error')
                }
            },
            onError: (error) => {
                showToaster(error?.data?.error || 'Something went wrong', '', 'error')
            }

        });

    }

    const handleJoinDemo = () => {
        if (meetingLink?.join_url) {
            window.open(meetingLink.join_url, '_blank');
            handleStudentAtd()
        }
    }

    return (
        <>
            <CardContainer>
                <CardMedia
                    sx={{
                        width: { lg: "35%", xs: "100%" },
                        borderRadius: "15px",
                        height: { lg: "auto", xs: "200px" }
                    }}
                    image={`${ImagePath}${ImageRelativePath}${cover_image}`}
                    alt={title}
                />
                <CardContent sx={{ flex: 1, px: { lg: "15px", xs: "0" } }}>
                    <Box sx={{ display: "grid", gridTemplateColumns: "auto max-content", alignItems: "center" }}>
                        <Box sx={{ minWidth: 0 }}>
                            <MovingText text={title} variant={"h5"} />
                            <Typography variant='h6' color='secondary.light'>{category_name}</Typography>
                        </Box>

                    </Box>
                    <Box sx={{ my: 1 }}>
                        {[details, additionalDetails].map((group, index) => (
                            <Box key={index}>
                                {group.map(({ label, value }, idx) => (
                                    <Typography key={idx} fontSize={"13px"} variant="body2">
                                        {label}{" "}
                                        {value ? (
                                            label === "status" ? (
                                                <>
                                                    <Typography
                                                        component="span"
                                                        fontSize={"13px"}
                                                        sx={{ color: getCourseStatusColor(course_status) }}
                                                    >
                                                        {value}
                                                    </Typography>

                                                </>

                                            ) : (
                                                value
                                            )
                                        ) : (
                                            ""
                                        )}
                                    </Typography>
                                ))}

                            </Box>

                        ))}
                        <Box sx={{ minWidth: "max-content" }}>
                            <Typography
                                component="span"
                                sx={{ color: "#4CAF50" }}
                            >
                                {apartment_name ? "Offline" : "Online"}
                            </Typography>
                        </Box>
                    </Box>
                    <Box my={2}> <ProgressBar /></Box>
                    <Button variant='contained' fullWidth
                        disabled={apartment_name ?? course_status !== "Ongoing Class"}
                        onClick={handleJoinDemo}
                    >
                        Join Class
                    </Button>
                </CardContent>
            </CardContainer>
        </>
    );
}

export default CurrentClassCard;
